module.exports = __webpack_public_path__ + "img/Rio-Secco.38828ded.jpg";